import React from 'react';
import {Jumbotron, Button, Container} from 'reactstrap';


const jumbo = (props) => {
    const jumboStyle = {
        background: 'linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url(' + props.image + ')'
    };

    return(
        <Jumbotron style={jumboStyle}>
            <Container>
                <h1 className="display-3">{props.title}</h1>
                <p className="lead">{props.content}</p>
                {props.button === "true" ? (<p className="lead">
                    <Button color="warning">Learn More</Button>
                </p>) : null}
            </Container>
        </Jumbotron>
    )
}

export default jumbo;


// WEBPACK FOOTER //
// ./src/components/Jumbo/Jumbo.js